import React, {useState, useEffect} from "react";
import UnauthorizedPage from "../../layouts/UnauthorizedPage";
import { PieChart2, StackedBarChart } from "../../layouts/ChartLayout";
import "../../../dashboard-components/loader.css"
import ModernTimeDropdown from "../../layouts/modernDropdown";
import server from "../../../api/server";

const BillingDashboard = ({clientID, serviceID}) => {
    const [activeTab, setActiveTab] = useState('overview');
    const [role] = useState(()=> {
      const userCookie = getCookie('dashboard_login_user_creds');
      if (userCookie) {
        const userData = JSON.parse(userCookie);
        const role = userData.role
        return role
      }
      return 'admin';
    })
    const [loading, setLoading] = useState(false)
    const colors = [
      "#10B981", // green
      "#3B82F6", // blue
      "#F59E0B", // amber
      "#F35858", // red
      "#84CC16", // lime
      "#956BF8", // violet
      "#06B6D4", // cyan
      "#EC4899", // pink
      "#0EA5E9", // sky-500 (bright sky blue)
      "#EAB308", // yellow
      "#F97316" // orange
    ];
    function getCookie(name) {
      function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
      var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
      return match ? match[1] : null;
  }
  const [client_id, setClient_id] = useState(null)
  const [service_id, setService_id] = useState(null)
  const [email, setEmail] = useState(null)
  const [currentBalance, setCurrentBalance] = useState(0)
  const [overuseBalance, setOveruseBalance] = useState(0)
  const [plansData, setPlansData] = useState({})
  const [months, setMonths] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [dailyMetrics, setDailyMetrics] = useState([])
  const [categories, setCategories] = useState([])
  const [pieData, setPieData] = useState([])
  const [transactions, setTransactions] = useState([])
  const roundToTwoDecimals = (value) => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? Number(numericValue.toFixed(2)) : value;
  };

  const getAllData = async() => {
    try {
      setLoading(true)
      let resp1;
      let resp2;
      let resp3;
      let resp4;
      let resp5;
      let resolvedCategories = [];
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      
      const [monthName, year] = selectedMonth.split(" ");   // ["April","2025"]
      const monthNumber = monthNames.indexOf(monthName) + 1;
      let api1 = server.getClientBalanceSnapshot(client_id, service_id, email, 'billing', undefined)
      let api2 = server.getClientDailyUsageSummary(client_id, service_id, email, 'billing', undefined, monthNumber, year)
      let api3 = server.getClientMonthlyUsageSummary(client_id, service_id, email, 'billing', undefined, monthNumber, year)
      let api4 = server.getClientTransactionsDetails(client_id, service_id, email, 'billing', undefined)
      let api5 = server.getClientPlansDetails(client_id, service_id, email, 'billing', undefined)
      let [res1, res2, res3, res4, res5] = await Promise.all([api1, api2, api3, api4, api5])
      if(res1.status === 200){
        resp1 = await res1.json()
        setCurrentBalance(resp1.data.current_balance)
        setOveruseBalance(resp1.data.overuse_balance)
      }
      if(res2.status === 200){
        resp2 = await res2.json()
        const roundedDailyUsage = (resp2.data || []).map((row) =>
          Object.fromEntries(
            Object.entries(row).map(([key, value]) => [
              key,
              key === 'date' ? value : roundToTwoDecimals(value),
            ])
          )
        );
        const firstRow = roundedDailyUsage[0] || {};

        // grab all keys except "date"
        const cats = Object
          .keys(firstRow)
          .filter(key => key !== 'date');

        resolvedCategories = cats;
        setCategories(cats);
        setDailyMetrics(roundedDailyUsage)
      }
      if(res3.status === 200){
        resp3 = await res3.json()
        const roundedMonthlyUsage = (resp3.data || []).map((entry) => ({
          ...entry,
          value: roundToTwoDecimals(entry.value),
        }));
        const fallbackOrder = roundedMonthlyUsage.map((item) => item.name);
        const colorForName = (name) => {
          const primaryIndex = resolvedCategories.indexOf(name);
          if (primaryIndex !== -1) return colors[primaryIndex % colors.length];
          const fallbackIndex = fallbackOrder.indexOf(name);
          return colors[(fallbackIndex === -1 ? 0 : fallbackIndex) % colors.length];
        };
        const pieDataWithFixedColors = roundedMonthlyUsage.map((entry) => ({
          ...entry,
          fill: colorForName(entry.name),
        }));
        setPieData(pieDataWithFixedColors)
      }
      if(res4.status === 200){
        resp4 = await res4.json()
        setTransactions(resp4.data)
      }
      if(res5.status === 200){
        resp5 = await res5.json()
        const apiPlans = resp5?.data || {}
        setPlansData(apiPlans)
      } else {
        setPlansData({})
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  function getCookie(name) {
    function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
    const match = document.cookie.match(new RegExp('(^|;\\s*)' + escape(name) + '=([^;]*)'));
    return match ? match[2] : null;
  }

  useEffect(()=> {
    if(client_id && service_id && role !== 'employee' && role !== 'manager'){
      getAllData()
    }
  }, [selectedMonth])

  useEffect(() => {
    const now = new Date();
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const generatedMonths = [];

    for (let i = 0; i < 6; i++) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const formatted = `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
      generatedMonths.push(formatted);
    }

    setMonths(generatedMonths);
    setSelectedMonth(generatedMonths[0]); // current month
    if(clientID){
      setClient_id(clientID)
    }
    if(serviceID){
      setService_id(serviceID)
    }
    const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
    setEmail(user.email)
  }, [clientID, serviceID]);
  useEffect(()=> {
    if(client_id && service_id && email){
      getAllData()
    }
  }, [client_id, service_id, email])
  const getReadableDateFromEpoch = (time) => {
    const date = new Date(time * 1000);
    return date.toLocaleDateString('en-GB', {
      day:   '2-digit',
      month: 'short',   // e.g. “Apr”
      year:  'numeric'
    });
  }; 
  const handleDownload = (rows, title) => {
    if (!rows || rows.length === 0) return;
    const headers = Object.keys(rows[0]);
    const lines = [
      headers.join(","),                                    // header row
      ...rows.map(r => headers.map(h => r[h]).join(","))    // data rows in header order
    ];
    const csvContent = "data:text/csv;charset=utf-8," + lines.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${title}_data.csv`);
    document.body.appendChild(link);
    link.click();
  }
  const formatPricingType = (value) => {
    if (!value) return "";
    if (value === "per_minute") return "Per minute";
    if (value === "per_chat") return "Per chat";
    return value.replaceAll("_", " ");
  };
  const formatFrequency = (value) => {
    if (!value) return "-";
    return String(value).replaceAll("_", " ");
  };
  const formatInrPrice = (value, suffix = "") => {
    if (value === null || value === undefined || value === "") return "-";
    return `INR ${value}${suffix ? ` ${suffix}` : ""}`;
  };
  const formatBillingItem = (price, frequency) => {
    const priceStr = formatInrPrice(price);
    const freq = formatFrequency(frequency);
    return freq !== "-" ? `${priceStr} (${freq})` : priceStr;
  };

  const analyticsPlans = plansData?.analytics || {};
  const voiceAIPlans = plansData?.voice_ai || {};
  const widgetVoicePlans = plansData?.widget_voice;
  const widgetChatPlans = plansData?.widget_chat;
  const minimumBilling = analyticsPlans?.minimum_billing || {};
  const platformFeesPlans = plansData?.platform_fees || {};
  return (
    <div className={`${role!=='employee' && 'py-3 px-5'} bg-gray-50`} style={{height: "100%"}}>
      {role !== 'employee' && role !== 'manager' && <>
      <div className="mb-8">
        <h1 className="text-xl font-semibold text-gray-900 mb-2">Billing</h1>
        <p className="text-gray-500 text-sm">Manage your billing details and usage</p>
      </div>

      <div className="flex space-x-6 text-gray-600 mb-6">
        <button 
          className={`px-3 py-2 ${activeTab === 'overview' ? 'bg-gray-100 text-gray-800 font-medium rounded' : 'hover:text-gray-900'}`}
          onClick={() => setActiveTab('overview')}
        >
          Overview
        </button>
        <button 
          className={`px-3 py-2 ${activeTab === 'transactions' ? 'bg-gray-100 text-gray-800 font-medium rounded' : 'hover:text-gray-900'}`}
          onClick={() => setActiveTab('transactions')}
        >
          Transactions
        </button>
        <button 
          className={`px-3 py-2 ${activeTab === 'plans' ? 'bg-gray-100 text-gray-800 font-medium rounded' : 'hover:text-gray-900'}`}
          onClick={() => setActiveTab('plans')}
        >
          Plans
        </button>
      </div>

      {/* Overview Tab */}
      {activeTab === 'overview' && (
        <div>
          {/* Credit Summary */}
          <div className={`flex gap-6 ${overuseBalance ? '' : 'mb-8'}`} style={{width: "20%"}}>
            <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm w-full">
              <p className="text-gray-500 text-sm mb-1">Credits remaining</p>
              <div className="flex items-baseline"><h2 className="text-4xl font-bold text-gray-700">{Math.round(currentBalance, 0)} </h2></div>
            </div>
            {/* <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm">
              <p className="text-gray-500 text-sm mb-1">Last 7 Days Usage</p>
              <h2 className="text-4xl font-bold text-gray-700">3,920</h2>
            </div> */}
          </div>
          {overuseBalance && (
              <div className="mb-8 flex mt-2">
                <p className="text-gray-500 text-xs mb-1">Allowed Overusages: </p>
                <h2 className="text-xs font-bold text-gray-500">{Math.abs(overuseBalance)} credits</h2>
              </div>
            )}

          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-semibold text-gray-700">Usage Details</h3>
            <ModernTimeDropdown value={selectedMonth} placeholder='Select Month'
              onChange={(e) => setSelectedMonth(e.target.value)} options={months}/>
          </div>
          
          {/* Usage Trends */}
          <div className="flex gap-6 mb-8">
            <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm w-3/5">
            { loading && (
                <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}><div className="loader"></div><div style={{textAlign: "center"}}>Loading <br/> Please Wait</div></div>)}
                {!loading && <StackedBarChart barColors={colors} data={dailyMetrics} xAxisKey="date" xAxisTitle="Date" categories={categories} yAxisTitle="Credits Used" title="Daily Usage Trend" handleDownload={handleDownload}/>}
            </div>
            <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm w-2/5">
              {/* <h4 className="font-medium text-gray-700 mb-2">Monthly Usage Trend</h4> */}
              <div>
              { loading && (
                <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}><div className="loader"></div><div style={{textAlign: "center"}}>Loading <br/> Please Wait</div></div>)}
              {!loading && <PieChart2 pieData={pieData}  width="w-full" colors={colors} title="Monthly Usage" handleDownload={handleDownload} />}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Transactions Tab */}
      {activeTab === 'transactions' && (
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Txn ID</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Credits</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Remarks</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {transactions.map((transaction) => (
                  <tr key={transaction.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{transaction.txn_id}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{getReadableDateFromEpoch(transaction.recharge_at)}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{transaction.credits}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{transaction.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Plans Tab */}
      {activeTab === 'plans' && (
        <div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:items-stretch md:auto-rows-fr">
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 h-full">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-md font-medium text-indigo-700 bg-indigo-50 px-4 py-1 rounded-full">Analytics</h3>
                {/* <span className="text-xs font-medium text-indigo-700 bg-indigo-50 px-2 py-1 rounded-full">Core</span> */}
              </div>
              <ul>
                <li className="text-sm text-gray-700 mb-3 p-3 bg-gray-50 rounded-lg border border-gray-100">
                  <p className="font-medium text-gray-900 mb-1">Calls</p>
                  <ul className="ml-4 list-disc">
                    <li className="text-sm text-gray-700 mb-1 capitalize">Plan Type: {analyticsPlans?.calls?.pricing_category || "-"}</li>
                    <li className="text-sm text-gray-700 mb-1">Pricing Type: {formatPricingType(analyticsPlans?.calls?.pricing_type) || "-"}</li>
                    <li className="text-sm text-gray-700 mb-1">Unit Price: {formatInrPrice(analyticsPlans?.calls?.unit_price)}</li>
                  </ul>
                </li>
                <li className="text-sm text-gray-700 mb-3 p-3 bg-gray-50 rounded-lg border border-gray-100">
                  <p className="font-medium text-gray-900 mb-1">Chats</p>
                  <ul className="ml-4 list-disc">
                    <li className="text-sm text-gray-700 mb-1 capitalize">Plan Type: {analyticsPlans?.chats?.pricing_category || "-"}</li>
                    <li className="text-sm text-gray-700 mb-1">Pricing Type: {formatPricingType(analyticsPlans?.chats?.pricing_type) || "-"}</li>
                    <li className="text-sm text-gray-700 mb-1">Unit Price: {formatInrPrice(analyticsPlans?.chats?.unit_price)}</li>
                  </ul>
                </li>
                <li className="text-sm text-gray-700 mb-3 p-3 bg-gray-50 rounded-lg border border-gray-100">
                  <span className="font-medium text-gray-900">Reports &amp; Training</span>
                  <ul className="mt-1 ml-4 list-disc">
                    <li className="text-sm text-gray-700 mb-1">Agent reports: {formatInrPrice(analyticsPlans?.reports?.agent_reports ?? 25, "per session")}</li>
                    <li className="text-sm text-gray-700 mb-1">Project Reports: {formatInrPrice(analyticsPlans?.reports?.team_reports ?? 25, "per session")}</li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 h-full">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-md font-medium text-emerald-700 bg-emerald-50 px-4 py-1 rounded-full">Voice AI</h3>
                {/* <span className="text-xs font-medium text-emerald-700 bg-emerald-50 px-2 py-1 rounded-full">Usage</span> */}
              </div>
              <ul>
                <li className="text-sm text-gray-700 mb-3 p-3 bg-gray-50 rounded-lg border border-gray-100 capitalize"><span className="font-medium text-gray-900">Plan Type:</span> {voiceAIPlans?.pricing_category || "-"}</li>
                <li className="text-sm text-gray-700 mb-3 p-3 bg-gray-50 rounded-lg border border-gray-100"><span className="font-medium text-gray-900">Pricing Type:</span> {formatPricingType(voiceAIPlans?.pricing_type) || "-"}</li>
                <li className="text-sm text-gray-700 mb-3 p-3 bg-gray-50 rounded-lg border border-gray-100"><span className="font-medium text-gray-900">Unit Price:</span> {formatInrPrice(voiceAIPlans?.unit_price)}</li>
                <li className="text-sm text-gray-700 mb-2 p-3 bg-gray-50 rounded-lg border border-gray-100"><span className="font-medium text-gray-900">Pulse:</span> {`${voiceAIPlans.pulse_seconds} seconds`}</li>
                <li className="text-sm text-gray-700 mb-2 p-3 bg-gray-50 rounded-lg border border-gray-100"><span className="font-medium text-gray-900">Phone Number Charges:</span> {`${voiceAIPlans.phone_number_charges}`}</li>
                {widgetVoicePlans && <li className="text-sm text-gray-700 mb-3 p-3 bg-gray-50 rounded-lg border border-gray-100">
                  <p className="font-medium text-gray-900 mb-1">Widget Voice</p>
                  <p>{formatInrPrice(widgetVoicePlans.unit_price)} · {formatPricingType(widgetVoicePlans.pricing_type)}</p>
                  <p>Pulse: {widgetVoicePlans.pulse_seconds} seconds</p>
                </li>}
                {widgetChatPlans && <li className="text-sm text-gray-700 p-3 bg-gray-50 rounded-lg border border-gray-100">
                  <p className="font-medium text-gray-900 mb-1">Widget Chat</p>
                  <p>{formatInrPrice(widgetChatPlans.unit_price)} · {formatPricingType(widgetChatPlans.pricing_type)}</p>
                  <p className="text-xs text-gray-500 mt-1">Charged once per chat with a successful reply.</p>
                </li>}

              </ul>
            </div>
            <div className="flex flex-col gap-6 h-full min-h-0 self-stretch">
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 flex-1 flex flex-col min-h-0">
                <div className="mb-4">
                  <h3 className="text-md font-medium text-violet-700 bg-violet-50 px-4 py-1 rounded-full inline-block">Minimum Billing</h3>
                </div>
                <ul>
                  <li className="text-sm text-gray-700 mb-2 p-3 bg-gray-50 rounded-lg border border-gray-100">Conversation Analytics: {formatBillingItem(minimumBilling.conversation_analytics_price, minimumBilling.conversation_analytics_frequency)}</li>
                  <li className="text-sm text-gray-700 mb-2 p-3 bg-gray-50 rounded-lg border border-gray-100">Voice AI: {formatBillingItem(minimumBilling.voice_ai_price, minimumBilling.voice_ai_frequency)}</li>
                  <li className="text-sm text-gray-700 p-3 bg-gray-50 rounded-lg border border-gray-100">Platform: {formatBillingItem(minimumBilling.platform_price, minimumBilling.platform_frequency)}</li>
                </ul>
              </div>
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 flex-1 flex flex-col min-h-0">
                <div className="mb-4">
                  <h3 className="text-md font-medium text-amber-700 bg-amber-50 px-4 py-1 rounded-full inline-block">Platform Fees</h3>
                </div>
                <ul>
                  <li className="text-sm text-gray-700 mb-2 p-3 bg-gray-50 rounded-lg border border-gray-100"><span className="font-medium text-gray-900">Frequency:</span> {formatFrequency(platformFeesPlans.frequency)}</li>
                  <li className="text-sm text-gray-700 p-3 bg-gray-50 rounded-lg border border-gray-100"><span className="font-medium text-gray-900">Price:</span> {formatInrPrice(platformFeesPlans.price)}</li>
                </ul>
              </div>
            </div>
            {!plansData || Object.keys(plansData).length === 0 ? (
              <div className="col-span-full bg-white rounded-xl border border-gray-200 shadow-sm p-6 text-sm text-gray-500">
                No plan details available.
              </div>
            ) : null}
          </div>
        </div>
      )}
      </>}
      {
        (role === 'manager' || role === 'employee') && (
          <UnauthorizedPage/>
        )
      }
    </div>
  );
};

export default BillingDashboard;
